import React from 'react';
import Screen from '../../components/common/Screen';
import Card from '../../components/elements/Card';
import Title from '../../components/common/Title';

// Registration for the delaware Sporty B1 — Hercules Trophy Edition is now
// closed. The page is kept on this route so bookmarked / shared links land
// on a polite "closed" message instead of a 404, but the Sharpspring form
// loader is no longer mounted.
const DelawareRegistration = () => (
  <Screen>
    <div className="center" style={{ width: '100%' }}>
      <Card p="0" style={{ width: 'min(34rem, calc(100% - 2rem))', overflow: 'hidden' }} mx="0">

        <div style={{ position: 'relative', width: '100%', height: '10rem', backgroundColor: '#002335' }}>
          <img
            src={require('./../../assets/images/sporty_B1_hercules_trophy_edition-banner-mailing-600x200 (1).png')}
            alt="delaware Sporty B1"
            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
          />
        </div>

        <div style={{ padding: '1.5rem', marginTop: '-2.5rem', position: 'relative' }}>
          <div className="d-flex flex-column align-items-center mb-3">
            <div style={{ width: '5rem', height: '5rem', borderRadius: '50%', backgroundColor: '#ffffff', padding: '0.35rem', boxShadow: '0 2px 8px rgba(0,0,0,0.12)', marginBottom: '0.75rem' }}>
              <img
                src={require('./../../assets/images/delaware-logo.jpg')}
                alt="delaware logo"
                style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: '50%' }}
              />
            </div>
            <Title my="0">delaware Sporty B1</Title>
          </div>

          <hr style={{ opacity: 0.12, marginBottom: '1.25rem' }} />

          <div style={{ backgroundColor: '#fff0f3', borderRadius: '8px', padding: '0.875rem 1rem', borderLeft: '3px solid #c42828', marginBottom: '1rem' }}>
            <p className="mb-1" style={{ fontWeight: 600, color: '#c42828' }}>Registration is closed</p>
            <p className="text-secondary mb-0" style={{ fontSize: '0.9rem' }}>
              Thank you for your interest. The Sporty B1 – Hercules Trophy Edition registration is no longer accepting submissions.
            </p>
          </div>

          <p className="text-secondary mb-0" style={{ fontSize: '0.88rem' }}>
            For any questions, please reach out to your delaware Event Team contact.
          </p>
        </div>

      </Card>
    </div>
  </Screen>
);

export default DelawareRegistration;
